import React, {useState, useEffect, useContext, Suspense, lazy} from "react";
import ApolloClient from "apollo-boost";
import {gql} from "apollo-boost";
import "./Project.css";
import Button from "../../components/button/Button";
import {openSource, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";


export default function Projects() {
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const FailedLoading = () => null;
  const renderLoader = () => <Loading />;
  const [repo, setrepo] = useState([]);
  // todo: remove useContex because is not supported
  const {isDark} = useContext(StyleContext);
  useEffect(() => {
    getRepoData();
  }, []);

  function getRepoData() {
    const client = new ApolloClient({
      uri: "https://api.github.com/graphql",
      request: operation => {
        operation.setContext({
          headers: {
            authorization: `Bearer ${openSource.githubConvertedToken}`
          }
        });
      }
    });

    client
      .query({
        query: gql`
        {
        user(login: "${openSource.githubUserName}") {
          pinnedItems(first: 6, types: [REPOSITORY]) {
            totalCount
            edges {
              node {
                ... on Repository {
                  name
                  description
                  forkCount
                  stargazers {
                    totalCount
                  }
                  url
                  id
                  diskUsage
                  primaryLanguage {
                    name
                    color
                  }
                }
              }
            }
          }
        }
      }
        `
      })
      .then(result => {
        setrepoFunction(result.data.user.pinnedItems.edges);
        console.log(result);
      })
      .catch(function (error) {
        console.log(error);
        setrepoFunction("Error");
        console.log(
          "Because of this Error, nothing is shown in place of Projects section. Projects section not configured"
        );
      });
  }

  function setrepoFunction(array) {
    setrepo(array);
  }
  if (
    !(typeof repo === "string" || repo instanceof String) &&
    openSource.display
  ) {
    return (
      <section id="projects">
      <div class="container">
        <div class="project-wrapper">
          <h2 class="section-title dark-blue-text">
            Projects
          </h2>

         { /* Each .row is a project */}
          <div class="row">
            <div class="col-lg-4 col-sm-12">
              <div class="project-wrapper__text">
                <h3 class="project-wrapper__text-title">Project Title</h3>
                <div>
                  <p class="mb-4">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Excepturi neque, ipsa animi maiores repellendus distinctio
                    aperiam earum dolor voluptatum consequatur blanditiis
                    inventore debitis fuga numquam voluptate ex architecto
                    itaque molestiae.
                  </p>
                </div>
                <a target="_blank" class="cta-btn cta-btn--hero" href="#!">
                  See Live
                </a>
                <a target="_blank" class="cta-btn text-color-main" href="#!">
                  Source Code
                </a>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              <div class="project-wrapper__image">
                <a href="#!" target="_blank">
                  <div data-tilt class="thumbnail rounded">
                    <img class="img-fluid" src="./assets/project.jpg" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        { /* /END Project */}

          {/* Each .row is a project */}
          <div class="row">
            <div class="col-lg-4 col-sm-12">
              <div class="project-wrapper__text">
                <h3 class="project-wrapper__text-title">Project Title</h3>
                <div>
                  <p class="mb-4">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Excepturi neque, ipsa animi maiores repellendus distinctio
                    aperiam earum dolor voluptatum consequatur blanditiis
                    inventore debitis fuga numquam voluptate ex architecto
                    itaque molestiae.
                  </p>
                </div>
                <a target="_blank" class="cta-btn cta-btn--hero" href="#!">
                  See Live
                </a>
                <a target="_blank" class="cta-btn text-color-main" href="#!">
                  Source Code
                </a>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              <div class="project-wrapper__image">
                <a href="#!" target="_blank">
                  <div data-tilt class="thumbnail rounded">
                    <img class="img-fluid" src="./assets/project.jpg" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/* /END Project */}

          {/* Each .row is a project */}
          <div class="row">
            <div class="col-lg-4 col-sm-12">
              <div class="project-wrapper__text">
                <h3 class="project-wrapper__text-title">Project Title</h3>
                <div>
                  <p class="mb-4">
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Excepturi neque, ipsa animi maiores repellendus distinctio
                    aperiam earum dolor voluptatum consequatur blanditiis
                    inventore debitis fuga numquam voluptate ex architecto
                    itaque molestiae.
                  </p>
                </div>
                <a target="_blank" class="cta-btn cta-btn--hero" href="#!">
                  See Live
                </a>
                <a target="_blank" class="cta-btn text-color-main" href="#!">
                  Source Code
                </a>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              <div class="project-wrapper__image">
                <a href="#!" target="_blank">
                  <div data-tilt class="thumbnail rounded">
                    <img class="img-fluid" src="./assets/project.jpg" />
                  </div>
                </a>
              </div>
            </div>
          </div>
       {   /* /END Project */}
        </div>
      </div>
    </section>
    );
  } else {
    return <FailedLoading />;
  }
}
